#import '../fragments/marketing-automation-fragment.graphql'

query GetMoneyPages($first: Int, $after: String, $last: Int, $before: String) {
    maUrls(first: $first, after: $after, last: $last, before: $before) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
        }
        edges {
            cursor
            node {
                id
                name
                url {
                    id
                    fullyQualifiedUrl
                    pageTitle
                }
                creatorUser {
                    id
                }
                createdTime
                automation {
                    ...MarketingAutomationFragment
                }
                isEnabled
                lastTriggeredTime
                views
                htmlUrlPath
            }
        }
    }
}
